import { useIsFetching } from '@tanstack/react-query'
import { Logo } from '../ui/Logo'
import { UserMenu } from './UserMenu'

interface TopBarProps {
  onMenuClick: () => void
  /** true si el sidebar se ve expandido con etiquetas (en escritorio) o abierto (en movil). */
  expanded: boolean
}

export function TopBar({ onMenuClick, expanded }: TopBarProps) {
  const isFetching = useIsFetching()

  return (
    <header className="sticky top-0 z-10 flex items-center justify-between gap-3 border-none bg-panel/35 px-6 py-3.5 backdrop-blur-xl backdrop-saturate-150">
      <div className="flex items-center gap-3">
        <button
          className="flex h-9 w-9 items-center justify-center rounded-full bg-transparent text-lg text-text transition-colors hover:bg-panel-2"
          onClick={onMenuClick}
          aria-label={expanded ? 'Reducir menú' : 'Expandir menú'}
          aria-expanded={expanded}
        >
          ☰
        </button>
        <div className="hidden items-center gap-2 text-muted md:flex">
          <Logo size={20} />
          Tu centro personal de proyectos, ideas y tareas
        </div>
      </div>
      <div className="flex items-center gap-2.5">
        <span
          className="rounded-full border border-[#27694f] px-2.5 py-1.5 text-sm whitespace-nowrap text-green"
          role="status"
        >
          {isFetching ? 'Sincronizando…' : 'API conectada'}
        </span>
        <UserMenu />
      </div>
    </header>
  )
}
